import * as React from 'react';

import { Text } from '../../Text';
import { ICommercialInfoSchema } from '../../../repositories/favorites/entities/favorite_entity_for_desktop/CommercialInfoSchema';

export interface ICommercialInfoProps {
  commercialInfo: ICommercialInfoSchema;
}

export function CommercialInfo({ commercialInfo }: ICommercialInfoProps) {
  const { officeClassText, priceText } = commercialInfo;

  return (
    <>
      {officeClassText && (
        <div>
          <Text textSize="small" color="gray">
            {officeClassText}
          </Text>
        </div>
      )}
      {priceText && (
        <div>
          <Text textSize="small" color="gray">
            {priceText}
          </Text>
        </div>
      )}
    </>
  );
}
